import { SubMenu } from './SubMenu'
import { withSubMenu } from './withSubMenu'

const ConnectedSubMenu = withSubMenu(SubMenu)
export { ConnectedSubMenu as SubMenu }
